import { Uuid } from "@/dto/CommonDto.ts";

export class DeleteInspectorReqDto extends Uuid {}